export default __webpack_public_path__ + "static/media/warningIconOrange.ff31a3bc.svg";